import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  APPOINTMENT_FEATURE_KEY,
  State,
  AppointmentPartialState,
  appointmentAdapter
} from './appointment.reducer';

// Lookup the 'Appointment' feature state managed by NgRx
export const getAppointmentState = createFeatureSelector<
  AppointmentPartialState,
  State
>(APPOINTMENT_FEATURE_KEY);

const { selectAll, selectEntities } = appointmentAdapter.getSelectors();

export const getAppointmentLoading = createSelector(
  getAppointmentState,
  (state: State) => state.loading
);

export const getAppointmentUpdating = createSelector(
  getAppointmentState,
  (state: State) => state.updating
);

export const getAppointmentError = createSelector(
  getAppointmentState,
  (state: State) => state.error
);

export const getAllAppointment = createSelector(
  getAppointmentState,
  (state: State) => selectAll(state)
);

export const getAppointmentEntities = createSelector(
  getAppointmentState,
  (state: State) => selectEntities(state)
);

export const getSelectedId = createSelector(
  getAppointmentState,
  (state: State) => state.selectedId
);

export const getSelected = createSelector(
  getAppointmentEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);

export const getPosition = createSelector(
  getAppointmentState,
  (state: State) => state.position
);
